import { render, staticRenderFns } from "./TableFieldConfiguratorColumns.vue?vue&type=template&id=ecfc6ecc&"
import script from "./TableFieldConfiguratorColumns.vue?vue&type=script&lang=js&"
export * from "./TableFieldConfiguratorColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports